export default __webpack_public_path__ + "static/media/face_dummy.8dd2d387.jpg";